define("settings/controllers/subscription/index", ["exports", "@ember/controller", "@ember/object", "@ember/service", "@ember/utils", "@glimmer/tracking"], function (_exports, _controller, _object, _service, _utils, _tracking) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;

  var _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7, _descriptor8, _descriptor9, _descriptor10, _descriptor11, _descriptor12, _descriptor13, _descriptor14;

  0; //eaimeta@70e063a35619d71f0,"@ember/controller",0,"@ember/object",0,"@ember/service",0,"@ember/utils",0,"@glimmer/tracking"eaimeta@70e063a35619d71f

  function _initializerDefineProperty(target, property, descriptor, context) { if (!descriptor) return; Object.defineProperty(target, property, { enumerable: descriptor.enumerable, configurable: descriptor.configurable, writable: descriptor.writable, value: descriptor.initializer ? descriptor.initializer.call(context) : void 0 }); }

  function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

  function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) { var desc = {}; Object.keys(descriptor).forEach(function (key) { desc[key] = descriptor[key]; }); desc.enumerable = !!desc.enumerable; desc.configurable = !!desc.configurable; if ('value' in desc || desc.initializer) { desc.writable = true; } desc = decorators.slice().reverse().reduce(function (desc, decorator) { return decorator(target, property, desc) || desc; }, desc); if (context && desc.initializer !== void 0) { desc.value = desc.initializer ? desc.initializer.call(context) : void 0; desc.initializer = undefined; } if (desc.initializer === void 0) { Object.defineProperty(target, property, desc); desc = null; } return desc; }

  function _initializerWarningHelper(descriptor, context) { throw new Error('Decorating class property failed. Please ensure that ' + 'proposal-class-properties is enabled and runs after the decorators transform.'); }

  let IndexController = (_class = class IndexController extends _controller.default {
    constructor() {
      super(...arguments);

      _initializerDefineProperty(this, "address", _descriptor, this);

      _initializerDefineProperty(this, "alerts", _descriptor2, this);

      _initializerDefineProperty(this, "auth", _descriptor3, this);

      _initializerDefineProperty(this, "cancellation", _descriptor4, this);

      _initializerDefineProperty(this, "errors", _descriptor5, this);

      _initializerDefineProperty(this, "intl", _descriptor6, this);

      _initializerDefineProperty(this, "onboarding", _descriptor7, this);

      _initializerDefineProperty(this, "payment", _descriptor8, this);

      _initializerDefineProperty(this, "settings", _descriptor9, this);

      _initializerDefineProperty(this, "seamlessCheckoutManager", _descriptor10, this);

      _initializerDefineProperty(this, "subscriptions", _descriptor11, this);

      _defineProperty(this, "defaultDateFormat", 'MMM D, YYYY');

      _initializerDefineProperty(this, "showSocialSetsInfo", _descriptor12, this);

      _initializerDefineProperty(this, "showUserInfo", _descriptor13, this);

      _initializerDefineProperty(this, "showContactUsModal", _descriptor14, this);
    }

    get currentAccount() {
      return this.auth.currentAccount;
    }

    get hasCancelledSubscription() {
      return this.subscriptions.hasCurrentSubscription && this.auth.currentAccount.hasActiveCancelledSubscription;
    }

    get subscriptionPlan() {
      return this.subscriptions.subscriptionPlan;
    }

    get hasActiveTrial() {
      return this.subscriptions.hasActiveTrial;
    }

    get upcomingSubscriptionPlan() {
      return this.subscriptions.upcomingSubscriptionPlan;
    }

    get canAddAiCredits() {
      return this.subscriptionPlan.canAddAiCredits;
    }

    get canUpgrade() {
      return this.subscriptions.canUpgrade;
    }

    get hasUpcomingDowngrade() {
      return this.subscriptions.hasUpcomingDowngrade;
    }

    get hasSubscription() {
      return this.subscriptions.hasCurrentSubscription;
    }

    get upcomingPlanChangesDate() {
      return this.subscription.upcomingPlanChanges.activeAtMoment;
    }

    get upcomingAiCreditsQuantity() {
      return this.subscription.upcomingAiCreditsChanges?.quantity;
    }

    get upcomingAiCreditsChangesDate() {
      return this.subscription.upcomingAiCreditsChanges.activeAtMoment;
    }

    get upcomingSocialSetQuantity() {
      return this.subscription.upcomingSocialSetChanges?.quantity;
    }

    get upcomingSocialSetChangesDate() {
      return this.subscription.upcomingSocialSetChanges?.activeAtMoment;
    }

    get upcomingUserQuantity() {
      return this.subscription.upcomingUserChanges?.quantity;
    }

    get upcomingUserChangesDate() {
      return this.subscription.upcomingUserChanges.activeAtMoment;
    }

    get hasUpcomingAiCreditsChanges() {
      const currentQuantity = this.subscription.additionalAiCredits;
      const upcomingQuantity = this.upcomingAiCreditsQuantity;
      return (0, _utils.isPresent)(currentQuantity) && (0, _utils.isPresent)(upcomingQuantity) && currentQuantity !== upcomingQuantity;
    }

    get hasUpcomingIntervalChanges() {
      const currentInterval = this.subscriptionPlan?.interval;
      const upcomingInterval = this.upcomingSubscriptionPlan?.interval;
      return currentInterval && upcomingInterval && currentInterval !== upcomingInterval;
    }

    get hasUpcomingSocialSetChanges() {
      const currentQuantity = this.subscription.additionalSocialSets;
      const upcomingQuantity = this.upcomingSocialSetQuantity;
      return (0, _utils.isPresent)(currentQuantity) && (0, _utils.isPresent)(upcomingQuantity) && currentQuantity !== upcomingQuantity;
    }

    get hasUpcomingUserChanges() {
      const currentQuantity = this.subscription.additionalUsers;
      const upcomingQuantity = this.upcomingUserQuantity;
      return (0, _utils.isPresent)(currentQuantity) && (0, _utils.isPresent)(upcomingQuantity) && currentQuantity !== upcomingQuantity;
    }

    get showAddressBanner() {
      return this.address.showAddressBanner;
    }

    get showCancelTrialButton() {
      return this.hasActiveTrial && !this.hasCancelledSubscription && !this.subscriptions.isOnCardlessTrial;
    }

    get showCancelPlanButton() {
      // Note: subscriptionPlan.isPaid returns true while on a free trial
      return !this.hasActiveTrial && this.subscriptionPlan.isPaid && !this.hasCancelledSubscription;
    }

    get showChangePlan() {
      if (this.subscriptions.subscriptionPlan?.isAgency30Plan) {
        return false;
      }

      return this.canUpgrade || this.hasCancelledSubscription || this.subscriptions.hasActiveTrial;
    }

    get subscription() {
      if (this.subscriptions.subscription?.id) {
        return this.subscriptions.subscription;
      }

      return {
        additionalSocialSets: 0,
        additionalUsers: 0,
        additionalAiCredits: 0
      };
    }

    get isLegacyAccount() {
      return this.auth.currentAccount.isOnLegacyPlan && !this.auth.currentAccount.pricingV1Free;
    }

    get isMobileSubscription() {
      return this.subscriptions.isMobileSubscription;
    }

    cancelPlan() {
      if (this.subscriptions.isOnAgencyPlan) {
        return this.alerts.info(this.intl.t('plans.scale_plans.cancel_message'), {
          title: this.intl.t('plans.scale_plans.cancel_title'),
          sticky: true,
          preventDuplicates: true
        });
      }

      this.cancellation.startCancellationFlow.perform('subscription');
    }

    cancelTrial() {
      this.cancellation.startCancellationFlow.perform('subscription');
    }

    trackChangePlan(subscription) {
      this.settings.trackChangePlan.perform(subscription);
    }

  }, (_descriptor = _applyDecoratedDescriptor(_class.prototype, "address", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "alerts", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "auth", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "cancellation", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "errors", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor6 = _applyDecoratedDescriptor(_class.prototype, "intl", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor7 = _applyDecoratedDescriptor(_class.prototype, "onboarding", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor8 = _applyDecoratedDescriptor(_class.prototype, "payment", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor9 = _applyDecoratedDescriptor(_class.prototype, "settings", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor10 = _applyDecoratedDescriptor(_class.prototype, "seamlessCheckoutManager", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor11 = _applyDecoratedDescriptor(_class.prototype, "subscriptions", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor12 = _applyDecoratedDescriptor(_class.prototype, "showSocialSetsInfo", [_tracking.tracked], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function () {
      return false;
    }
  }), _descriptor13 = _applyDecoratedDescriptor(_class.prototype, "showUserInfo", [_tracking.tracked], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function () {
      return false;
    }
  }), _descriptor14 = _applyDecoratedDescriptor(_class.prototype, "showContactUsModal", [_tracking.tracked], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function () {
      return false;
    }
  }), _applyDecoratedDescriptor(_class.prototype, "cancelPlan", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "cancelPlan"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "cancelTrial", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "cancelTrial"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "trackChangePlan", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "trackChangePlan"), _class.prototype)), _class);
  _exports.default = IndexController;
});